import React from 'react'
import './annualreport.scss'
import {MainHeading, VideoPlayer, AnnualReport , CommonCard ,FigureCards , OurProgress } from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
import LeadershipCardData from "./data.json";
const AnnualReportMain = () => {

  const revenueData = [
    {
      id: 1,
      value: "$4.3B",
      unit: "Premium revenue",
      description: "Our 2023 premium total represents a 10% increase from the previous year.",
    },
    {
      id: 2,
      value: "$8B",
      unit: "Policyholder surplus",
      description: "We provided $2.1B in claim payouts in 2023 to support our policyholders.",
    },
    {
      id: 3,
      value: "32",
      unit: "Years",
      description: "Our high retention rate reflects the trust of our customers.",
    },
  ];

  const reportsData = [
    {
      id: 1,
      name: '2022 Annual Report',
      link: '',
      icon: images['download.svg'],
    },
    {
      id: 2,
      name: '2021 Annual Report',
      link: '',
      icon: images['download.svg'],
    },
    {
      id: 3,
      name: '2020 Annual Report',
      link: '',
      icon: images['download.svg'],
    },
  ];

  return (
    <>
      <Container>
        {/* heading  */}
        <MainHeading title="Our 2023 Year in Review" showshare = {false} />
        {/* Layout */}
        <Row>
          <Col sm={12} md={12} lg={12} xl={12}>
            <AnnualReport />
            <VideoPlayer videoSrc="https://www.w3schools.com/html/mov_bbb.mp4" />
            <FigureCards data={revenueData}/>
          </Col>
        </Row>
        <div className='bottom-container'>
          <CommonCard Title="Explore our Year in Review videos" CardData={LeadershipCardData} colSizes={{lg: 6, xl: 6 }}/>
          <OurProgress data={reportsData}/>
        </div>
      </Container>
    </>
  )
}

export default AnnualReportMain